import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { settingsStoreToken } from '../../../../../../../cross-team-shared/state/setting-state';
import { SettingsService } from '../../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { viewAllIcon } from '../../../../../../shared/icons/toolbars/view-all-icon';
import { viewNoneIcon } from '../../../../../../shared/icons/toolbars/view-none-icon';
import { viewSelectedIcon } from '../../../../../../shared/icons/toolbars/view-selected-icon';
import { RootKeyboardShortcutService } from '../../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Component({
  selector: 'h3-toggle-view-modes-button',
  templateUrl: './toggle-view-modes-button.component.html',
  styleUrl: './toggle-view-modes-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleViewModesButtonComponent {
  private readonly settingsStore = inject(settingsStoreToken);
  private readonly shortcutService = inject(RootKeyboardShortcutService);
  private readonly settingsService = inject(SettingsService);

  viewModeIcons = {
    all: viewAllIcon,
    selected: viewSelectedIcon,
    none: viewNoneIcon,
    layers: undefined,
  };
  viewModeIcon$ = this.settingsStore('viewMode').$.pipe(
    map((viewMode) => this.viewModeIcons[viewMode]),
  );
  tooltip$ = this.settingsStore('viewMode').$.pipe(
    map(
      (viewMode) =>
        `View ${viewMode}${this.shortcutService.tooltipSuffix('cycleViewMode')} `,
    ),
  );

  switchViewModes() {
    this.settingsService.toggleViewMode({ source: 'button' });
  }
}
